import { render, staticRenderFns } from "./ROIOverview.vue?vue&type=template&id=dc4f4ec0&scoped=true"
import script from "./ROIOverview.vue?vue&type=script&lang=js"
export * from "./ROIOverview.vue?vue&type=script&lang=js"
import style0 from "./ROIOverview.vue?vue&type=style&index=0&id=dc4f4ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4f4ec0",
  null
  
)

export default component.exports